import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import NumberFormat from 'react-number-format'
import sanitizeHtml from 'sanitize-html'
import update from 'immutability-helper'

// Components
import Loader from '../utils/Loader'
import Searchbar from '../utils/Searchbar'
import SearchProductPrices from '../search/SearchProductPrices'
import Button from '../modal/Button'
import Modal from '../modal/Modal'

// State
import { addRoute } from '../../store/actions/route'
import { setpageTitle } from '../../store/actions/siteInfo'
import { userTokenUpdate, userLogout } from '../../store/actions/user'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

// CSS
import '../../css/toggles.css'

// Utils
import '../../utils/immutability-helper-extend'

class AdminProductPrices extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            data: {},
            showModal: false,
            error: '',
            updateLoading: false,
            updateSuccess: '',
            updateErrors: {},
            clearLoading: false,
            clearSuccess: '',
            clearErrors: {}
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Product Prices')
    }

    // ===================================================================================
    //  LOAD DATA
    // ===================================================================================
    componentDidMount() {
        this.loadData()
    }

    loadData() {
        const { user } = this.props
        
        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.get(REACT_APP_API_URL + 'store-pricing', { headers: AUTH_HEADER })
            .then((response) => {
                if (response.status === 403 || (response.data.status && response.data.status === 403)){
                    this.props.userLogout('admin')
                } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                    this.setState({ isLoading: false, error: response.data.message })
                } else {
                    this.setState({
                        isLoading: false,
                        data: {
                            sale_price: !!response.data.store_sale.sale_price ? response.data.store_sale.sale_price : '',
                            sale_price_type: response.data.store_sale.sale_price_type === 'dollar' ? true : false,
                            sale_types: response.data.sale_types,
                            price_types: response.data.price_types
                        }
                    })
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
                } else {
                    this.setState({ isLoading: false, error: err.message })
                }
            })
    }

    propegateItems(items){

        // Create a simple array of pricing object.  No need for ids and stuff
        items = items.map(item => {
            let prices = {}
            let price_type = false

            Object.keys(item.prices).map(key => {
                if (!item.prices[key].product_id) return false
                prices[key] = {
                    price: item.prices[key].price
                }

                price_type = item.prices[key].price_type === 'dollar' ? true : false
                return true
            })

            item.price_type = price_type
            item.prices = prices
            return item
        })

        this.setState({
            items: items
        })
    }

    // ===================================================================================
    //  INPUT CHANGE
    // ===================================================================================
    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault()
            this.handleSubmit()
        }
    }

    handleInputChange(event) {
        const { id, value } = event.target
        this.setState({
            data: {
                ...this.state.data,
                [id]: value
            }
        })
    }
    
    handleNumberChange(id, valueObject) {
        this.setState({
            data: {
                ...this.state.data,
                [id]: valueObject.value
            }
        })
    }

    handleCheckboxClick(event) {
        const { id } = event.target
        this.setState({
            data: {
                ...this.state.data,
                [id]: !this.state.data[id]
            }
        })
    }

    handleItemChange(name, value, itemIndex, saleIndex, priceType){
        // The item is an inner "sale" item
        if (saleIndex !== undefined){
            this.setState({
                items: update(this.state.items, {
                    [itemIndex]: {
                        showButton: { $set: true },
                        prices: {
                            $autoArray: {
                                [saleIndex]: {
                                    $auto: {
                                        price: { $set: value }
                                    }
                                }
                            }
                        }
                    }
                })
            })
        
        // We are updating the product price (only thing we can do at the time this was created)
        }else{
            this.setState({
                items: update(this.state.items, {
                    [itemIndex]: { 
                        price: { $set: value },
                        showButton: { $set: true }
                    }
                })
            })
        }
    }

    handleItemTypeChange(itemIndex){
        const initialValue = !!this.state.items[itemIndex] ? this.state.items[itemIndex].price_type : false

        this.setState({
            items: update(this.state.items, {
                [itemIndex]: {
                    price_type: { $set: !initialValue },
                    showButton: { $set: true }
                }
            })
        })
    }

    // ===================================================================================
    //  SUBMIT SALE
    // ===================================================================================
    handleClearSales(){
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            clearSuccess: '',
            clearErrors: {},
            clearLoading: true
        }, () => {
            
            const token = user.token
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
            return axios.post(REACT_APP_API_URL + 'product-price/clear', null, { headers: AUTH_HEADER })
                .then((response) => {

                    // Check user token
                    if (!!response.data.token) {
                        this.props.userTokenUpdate('admin', response.data.token)
                    } else {
                        this.props.userLogout('admin')
                    }

                    if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {

                        // Create error object
                        let errorObj = ''
                        if (!isEmpty(response.data.errors)) {
                            errorObj = response.data.errors
                        } else if (!isEmpty(response.data.error)) {
                            errorObj = { general: response.data.error }
                        } else {
                            errorObj = { general: response.data.message }
                        }

                        this.setState({
                            clearLoading: false,
                            clearErrors: errorObj
                        })

                    } else {
                        this.setState({
                            clearLoading: false,
                            clearSuccess: response.data.message
                        }, () => this.searchbar.search())
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        this.setState({
                            clearLoading: false,
                            clearErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                        })
                    } else {
                        this.setState({
                            clearLoading: false,
                            clearErrors: { general: err.message }
                        })
                    }
                })
        })
    }

    handleSaveStoreSale(){
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            updateLoading: true
        }, () => {
            const data = {
                price_type: !!this.state.data.sale_price_type ? 'dollar' : 'percentage',
                price: this.state.data.sale_price
            }

            const token = user.token
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
            return axios.post(REACT_APP_API_URL + 'cart-sale', data, { headers: AUTH_HEADER })
                .then((response) => {

                    // Check user token
                    if (!!response.data.token) {
                        this.props.userTokenUpdate('admin', response.data.token)
                    } else {
                        this.props.userLogout('admin')
                    }

                    if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {

                        // Create error object
                        let errorObj = ''
                        if (!isEmpty(response.data.errors)) {
                            errorObj = response.data.errors
                        } else if (!isEmpty(response.data.error)) {
                            errorObj = { general: response.data.error }
                        } else {
                            errorObj = { general: response.data.message }
                        }

                        this.setState({
                            updateLoading: false,
                            updateErrors: errorObj
                        })

                    } else {
                        this.setState({
                            updateLoading: false,
                            updateSuccess: response.data.message
                        })
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        this.setState({
                            updateLoading: false,
                            updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                        })
                    } else {
                        this.setState({
                            updateLoading: false,
                            updateErrors: { general: err.message }
                        })
                    }
                })
        })
    }

    // ===================================================================================
    //  SUBMIT ITEM
    // ===================================================================================
    handleItemSave(itemIndex){
        const { user } = this.props
        const item = this.state.items[itemIndex]
        const { id } = item

        this.setState({
            items: update(this.state.items, {
                [itemIndex]: {
                    $unset: ['errors'],
                    saved: { $set: false },
                    loading: { $set: true }
                }
            })
        }, () => {

            // Put data together
            let data = {
                price: item.price,
                price_type: !!item.price_type ? 'dollar' : 'percentage'
            }
            
            // Add sales and their prices
            if(!isEmpty(item.prices)){
                Object.keys(item.prices).map(saleType =>
                    data[saleType] = item.prices[saleType].price
                )
            }

            // Make request
            const token = user.token
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
            return axios.post(REACT_APP_API_URL + 'product-price/' + id, data, { headers: AUTH_HEADER })
                .then((response) => {

                    // Check user token
                    if (!!response.data.token) {
                        this.props.userTokenUpdate('admin', response.data.token)
                    } else {
                        this.props.userLogout('admin')
                    }

                    if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {

                        // Create error object
                        let errorObj = ''
                        if (!isEmpty(response.data.errors)) {
                            errorObj = response.data.errors
                        } else if (!isEmpty(response.data.error)) {
                            errorObj = { general: response.data.error }
                        } else {
                            errorObj = { general: response.data.message }
                        }

                        this.setState({
                            updateLoading: false,
                            items: update(this.state.items, {
                                [itemIndex]: {
                                    loading: { $set: false },
                                    errors: { $set: errorObj }
                                }
                            })
                        })

                    } else {
                        this.setState({
                            updateLoading: false,
                            items: update(this.state.items, {
                                [itemIndex]: {
                                    loading: { $set: false },
                                    saved: { $set: true }
                                }
                            })
                        })
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        this.setState({
                            updateLoading: false,
                            updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                        })
                    } else {
                        this.setState({
                            updateLoading: false,
                            updateErrors: { general: err.message }
                        })
                    }
                })
        })
    }

    // ===================================================================================
    //  RENDER
    // ===================================================================================
    render() {
        const { data, updateLoading, updateSuccess, updateErrors, clearLoading, clearSuccess, clearErrors } = this.state

        return (
            <div>
                <h1>Product Prices</h1>

                {/* Has error */}
                {this.state.error ? (
                    <div className="error">
                        {Object.keys(this.state.error).map(key =>
                            <span key={key}>{this.state.error[key]}</span>
                        )}
                    </div>

                // No error
                ) : (
                    
                    // Loading
                    this.state.isLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>

                    // Show form
                    ) : (
                        <div>
                            <div className="store-sale-container">

                                {!!updateErrors.general &&
                                    <div className="error msg_animate" dangerouslySetInnerHTML={{ __html: sanitizeHtml(updateErrors.general) }}></div>
                                }
                                {updateSuccess &&
                                    <div className="success msg_animate">{updateSuccess}</div>
                                }
                                
                                <div className="form-field inline-field">
                                    <label>Store Sale</label>

                                    <NumberFormat value={data.sale_price} placeholder="0.00" prefix={data.sale_price_type ? '$' : ''} suffix={!data.sale_price_type ? '%' : ''} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true}
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onValueChange={e => this.handleNumberChange('sale_price', e)}
                                    />

                                    <div className="tgl-wrap">
                                        <label className="tgl">
                                            <input type="checkbox" id="sale_price_type" value="dollar" checked={data.sale_price_type}
                                                onChange={e => this.handleCheckboxClick(e)}
                                            />
                                            <span data-on="$" data-off="%"></span>
                                        </label>
                                    </div>

                                    <button className={'btn submit-btn' + (updateLoading ? ' loading' : '')} onClick={() => this.handleSaveStoreSale()} disabled={updateLoading}><span>Set Sale</span></button>
                                </div>

                                <div className="btn_container">
                                    <button className={'btn right-aligned-btn'} onClick={() => this.setState({ showModal: true })} disabled={updateLoading}><span>Clear Product Sales</span></button>
                                    
                                    {/* MODAL */}
                                    {this.state.showModal &&
                                        <Modal title={'Clear Store Sales'} buttons={[
                                            {
                                                type: Button,
                                                text: 'Close',
                                                action: () => this.setState({ showModal: false, clearErrors: {}, clearSuccess: '' }),
                                                disabled: this.state.clearLoading
                                            },
                                            {
                                                type: Button,
                                                text: 'Yes',
                                                action: () => this.handleClearSales(),
                                                disabled: this.state.clearLoading
                                            }
                                        ]}>
                                            <div>
                                                {/* LOADING */}
                                                {clearLoading ? (
                                                    <div>
                                                        Clearing store slaes.<br />
                                                        Please do not refresh the page.
                                                        <div className="pt2 pb2">
                                                            <Loader />
                                                        </div>
                                                    </div>

                                                // Dialog messages
                                                ) : (
                                                    <div>
                                                        {(!isEmpty(clearSuccess) || !isEmpty(clearErrors)) ? (
                                                            <div>
                                                                {clearSuccess && <div className="success msg_animate">{clearSuccess}</div>}
                                                                {clearErrors.general &&
                                                                    <div className="error msg_animate" dangerouslySetInnerHTML={{ __html: sanitizeHtml(clearErrors.general) }}></div>
                                                                }
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                Are you should you want to clear ALL product sales?<br />
                                                                Note that sale prices for all products within your cart will be removed!
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </Modal>
                                    }
                                </div>
                            </div>

                            <Searchbar placeholder={"Search products"} component={SearchProductPrices} searchEndpoint={'product-search'} {...this.props} userType="admin"
                                propegateItems={this.propegateItems.bind(this)}
                                saleTypes={this.state.data.sale_types}
                                parentItems={this.state.items}
                                handleItemChange={this.handleItemChange.bind(this)}
                                handleItemTypeChange={this.handleItemTypeChange.bind(this)}
                                handleItemSave={this.handleItemSave.bind(this)}
                                onRef={ref => (this.searchbar = ref)}
                                labels={['Product', 'SKU', 'Regular Price', 'Discount Value', '% / $', '']}
                            />
                        </div>
                    )
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps, { addRoute, userTokenUpdate, userLogout, setpageTitle })(AdminProductPrices)



// WEBPACK FOOTER //
// ./src/components/admin/AdminProductPrices.js